(function () {
	// The autoplay timer inside the active banner dot is a CSS animation (see .hero-carousel__bullet).
	// Swiper holds its autoplay clock during the slide animation, on hover, while dragging and in a hidden tab;
	// these events (bubbling from <swiper-container>) keep the animation in step with it. The state is read after
	// the event, not taken from its type: w4d-carousel.js (listening first) may pause again inside a resume.
	const syncPaused = (e) => {
		if (!e.target.classList.contains('hero-carousel')) return;

		const swiper = e.detail[0];

		swiper.pagination?.el?.classList.toggle('is-paused', !swiper.autoplay.running || swiper.autoplay.paused);
	};

	document.addEventListener('swiperautoplaypause', syncPaused);
	document.addEventListener('swiperautoplaystop', syncPaused);
	document.addEventListener('swiperautoplayresume', syncPaused);
	document.addEventListener('swiperautoplaystart', syncPaused);

	// Without the loop autoplay ends on the last slide. Swiper keeps it "running" there (it just does not move on),
	// so the banner counts it as stopped: no timer, and the button offers play.
	const hasEnded = (swiper) =>
		!!swiper?.isEnd && !!swiper.params.autoplay.stopOnLastSlide && !swiper.params.loop && !swiper.params.rewind;

	// Pause/play button (WCAG 2.2.2). Stopped autoplay stays stopped: Swiper's own resume (mouse leave, tab shown)
	// only continues a paused autoplay. The stopped state also hides the timer (.is-stopped).
	// Swiper starts autoplay while it is being set up, before carousel.swiper exists: the events pass it along.
	const syncToggle = (carousel, swiper = carousel.swiper) => {
		const running = !!swiper?.autoplay?.running && !hasEnded(swiper);
		const toggle = carousel.querySelector('.hero-carousel__autoplay-toggle');

		swiper?.pagination?.el?.classList.toggle('is-ended', hasEnded(swiper));
		swiper?.pagination?.el?.classList.toggle('is-stopped', !running);
		if (!toggle) return;

		toggle.classList.toggle('is-stopped', !running);
		toggle.setAttribute('aria-label', running ? toggle.dataset.labelStop : toggle.dataset.labelPlay);
	};

	const syncFromEvent = (e) => {
		if (e.target.classList.contains('hero-carousel')) syncToggle(e.target, e.detail[0]);
	};

	document.addEventListener('swiperautoplaystart', syncFromEvent);
	document.addEventListener('swiperautoplaystop', syncFromEvent);
	document.addEventListener('swiperslidechange', syncFromEvent);

	document.addEventListener('click', (e) => {
		const toggle = e.target instanceof Element ? e.target.closest('.hero-carousel__autoplay-toggle') : null;
		const carousel = toggle?.closest('.hero-carousel');
		const swiper = carousel?.swiper;
		const autoplay = swiper?.autoplay;
		if (!autoplay) return;

		if (autoplay.running && !hasEnded(swiper)) {
			autoplay.stop();
		} else {
			// The last slide has no next slide: start over from the first
			if (hasEnded(swiper)) {
				if (autoplay.running) autoplay.stop();
				swiper.slideTo(0);
			}
			autoplay.start();
		}
	});

	// Banners set up before this ran (their autoplay start event was missed)
	customElements.whenDefined('swiper-container').then(() => {
		document.querySelectorAll('swiper-container.hero-carousel').forEach((carousel) => syncToggle(carousel));
	});
})();
